var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("search-bar", {
          attrs: {
            "config-module": "3300002",
            filter: _vm.searchConditions,
            "show-form-item": true,
            "ocr-tab": _vm.OCR_TAB_FINISHED.code
          },
          on: { toQuery: _vm.toQuery, change: _vm.searchChange }
        }),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("intelligent-booking-table", {
              attrs: {
                "row-data": _vm.rowData,
                "tab-type": "tabFinished",
                "config-module": "3300022"
              },
              on: {
                showDetails: function(e) {
                  return this$1.$emit("showDetails", e)
                },
                refresh: _vm.fetchData
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "intelligent-tab-finished",
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.queryPageHandler
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }